import * as React from 'react';
import { Link, menu, adminMenu, adminLoginMenu, adminLogoutMenu } from '../data';
import { NavItem } from '../shared';
import { withRouter } from 'react-router-dom';
import * as CreDtos from "../CRE.dtos";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import * as LoginActionCreators from "../actions/login.actions";
import { join } from 'path';


export type CREHeaderProps = {
    location?: any;
    currentUser?: any;
    research?: CreDtos.Research[];
    resources?: CreDtos.Publication[];
    news?: CreDtos.News[];
    aboutPeople?: CreDtos.AboutPeople[];
    groupAdvisoryGroups: boolean;
    showIndigenousAdvisoryGroup: boolean;
    showCALDAdvisoryGroup: boolean;
    showYouthAdvisoryGroup: boolean;
    showConsumerAdvisoryGroup: boolean;
    validate: Function;
}

export type CREHeaderAllProps = CREHeaderProps;

export type CREHeaderState = {
    displayMobileMenu: boolean,
    displaySearch: boolean,
    menu: Link[],
    submenuIndex: number
}

class CREHeader extends React.Component<CREHeaderAllProps, CREHeaderState> {
    constructor(props, context) {
        super(props, context);

        //this.props.validate();
        let menu = this.getMenu();
        this.state = { submenuIndex: undefined, displaySearch: false, displayMobileMenu: false, menu: menu };

        this.onSearchClicked = this.onSearchClicked.bind(this);
        this.onMenuClicked = this.onMenuClicked.bind(this);
        this.generateMenu = this.generateMenu.bind(this);
    }

    componentDidUpdate(prevProps: CREHeaderAllProps, prevState) {
        if (this.props.currentUser != prevProps.currentUser || this.props.research != prevProps.research) {
            let menu = this.getMenu();
            this.setState({ menu });
        }
        /* When loading the menu items from a anchor this will scroll to the section */
        if (this.props.location !== prevProps.location) {
            this.setState({ displayMobileMenu: false });
        }
    }

    getMenu() {
        let applicationMenu = JSON.parse(JSON.stringify(menu)); // deep clone
        // remove and add the research items
        applicationMenu[1].children = [];
        if(this.props.research) {
            this.props.research.forEach(r => {
                let anchor = r.anchor;
                if (!anchor) {
                    anchor = r.title.split(' ').join('');
                }
                applicationMenu[1].children.push({
                    name: r.title,
                    route: "/ProjectItem/" + anchor,
                    hash: "" //"#" + anchor
                });
            });
        } else {
            applicationMenu[1].children.push({
                name: '...loading',
                route: "/Project",
                hash: "" //"#" + anchor
            });
        }
        // find the resources index
        let resourceIndex: number = 2;
        let MAX_RESOURCES = 4;
        applicationMenu[resourceIndex].children = [];
        if (this.props.resources) {
            var count = 0;
            this.props.resources.forEach(r => {
                if (count == MAX_RESOURCES) {
                    applicationMenu[resourceIndex].children.push({
                        name: "See More...",
                        route: "/Resources",
                        hash: "" //"#" + anchor
                    });
                } else if (count < MAX_RESOURCES) {
                    let anchor = r.anchor;
                    if (!anchor) {
                        anchor = r.title.split(' ').join('');
                    }
                    let title = r.title;
                    if (title.length > 30) {
                        title = title.substr(0, 30) + '...'
                    }
                    applicationMenu[resourceIndex].children.push({
                        name: title,
                        route: "/ResourceItem/" + anchor,
                        hash: "" //"#" + anchor
                    });
                }
                count++;
            });
        } else {
            applicationMenu[resourceIndex].children.push({
                name: '...loading',
                route: "/Resources",
                hash: "" //"#" + anchor
            });
        }

        // publications
        let publicationsIndex: number = 3;

        // remove the news if there is none
        if (this.props.news && this.props.news.length == 0) {
            applicationMenu[0].children.pop();
        }

        // process About Us
        if (this.props.groupAdvisoryGroups || !this.props.showIndigenousAdvisoryGroup) {
            applicationMenu[0].children = applicationMenu[0].children.filter(f => f.route != '/IndigenousAdvisoryGroup');
        }
        if (this.props.groupAdvisoryGroups || !this.props.showCALDAdvisoryGroup) {
            applicationMenu[0].children = applicationMenu[0].children.filter(f => f.route != '/CALDAdvisoryGroup');
        }
        if (this.props.groupAdvisoryGroups || !this.props.showYouthAdvisoryGroup) {
            applicationMenu[0].children = applicationMenu[0].children.filter(f => f.route != '/YouthAdvisoryGroup');
        }
        if (this.props.groupAdvisoryGroups || !this.props.showConsumerAdvisoryGroup) {
            applicationMenu[0].children = applicationMenu[0].children.filter(f => f.route != '/ConsumerAdvisoryGroup');
        }

        if (!this.props.groupAdvisoryGroups) {
            applicationMenu[0].children = applicationMenu[0].children.filter(f => f.route != '/AdvisoryGroup');
        }

        return applicationMenu;
    }

    generateMenu() {
        let menuRender = this.state.menu.map((item, index) => { return <NavItem key={"menuItem" + index} to={item.route} hash={item.hash} items={item.children}>{item.name}</NavItem>; });
        return menuRender;
    }

    onMenuClicked() {
        this.setState({ displayMobileMenu: !this.state.displayMobileMenu });
    }

    onSearchClicked() {
        let displaySearch = !this.state.displaySearch;

        this.setState({ displaySearch: displaySearch });
    }
    render() {

        const { displaySearch } = this.state;
        const { displayMobileMenu } = this.state;


        var searchElement = displaySearch ?
            <input type="text" className="search" placeholder="type here" autoFocus />
            : undefined;

        var menuCss = `collapse navbar-collapse  ${displayMobileMenu ? "show" : ""}`;

        return (<nav className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top ">
            <div className="container">
                <div className="navbar-header ">
                    <a href="/" className="navbar-brand">
                        <img src={require("../assets/img/logo.jpg")} />
                    </a>
                    <div className="navbar flex-xs-column pull-right ">
                        <button onClick={this.onMenuClicked} className="btn btn-primary navbar-toggler mobile-toggler" type="button">
                            <span className="fa fa-bars fa-4x"></span>
                        </button>
                    </div>
                </div>
                <div className={menuCss} id="navbarCollapse">
                    <div className="navbar-nav ml-auto mt-3">
                        {this.generateMenu()}
                    </div>
                </div>

            </div>
        </nav>);
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        currentUser: state.discussionBoard.currentUser,
        studentsAndTrainees: state.siteData.siteData.studentAndTrainees,
        aboutPeople: state.siteData.siteData.aboutPeople,
        isLoading: state.siteData.isLoading,
        research: state.siteData.siteData.research,
        resources: state.siteData.siteData.resources,
        news: state.siteData.siteData.news,
        groupAdvisoryGroups: state.siteData.groupAdvisoryGroups,
        showIndigenousAdvisoryGroup: state.siteData.showIndigenousAdvisoryGroup,
        showCALDAdvisoryGroup: state.siteData.showCALDAdvisoryGroup,
        showYouthAdvisoryGroup: state.siteData.showYouthAdvisoryGroup,
        showConsumerAdvisoryGroup: state.siteData.showConsumerAdvisoryGroup,
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            validate: LoginActionCreators.loginValidate
        },
        dispatch
    );
};


const CREHeaderContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(
    CREHeader
));

export default CREHeaderContainer;

// logo flex-xs-column 
// menuCss - flex-md-column  pull-xs-right


// WEBPACK FOOTER //
// ./src/pages/CREHeader.tsx